
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 4.832v5.693l4.213-2.985L12 4.832zm-2 4.776V3.916c0-1.187 1.313-1.904 2.311-1.262l4.984 3.204a2 2 0 01.074 3.314L13.377 12l3.992 2.828a2 2 0 01-.074 3.314l-4.984 3.204c-.998.642-2.31-.075-2.31-1.262v-5.692l-3.423 2.424a1 1 0 11-1.156-1.632L9.917 12 5.422 8.816a1 1 0 011.156-1.632L10 9.608zm2 3.867v5.693l4.213-2.708L12 13.475z"}})])
          )
        }
      }
    